import { User } from './user';
import { Commodity } from './commodity';
import { Packaging } from './packaging';

export class CommodityPackaging {
  commodity_uuid!: string;
  packaging_uuid!: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  commodity?: Commodity;
  packaging?: Packaging;

  static getSortColumns() {
    return ['status'];
  }

  constructor(data: any) {
    this.commodity_uuid = data.commodity_uuid;
    this.packaging_uuid = data.packaging_uuid;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.commodity) {
      this.commodity = new Commodity(data.commodity);
    }
    if (data.packaging) {
      this.packaging = new Packaging(data.packaging);
    }
  }
}
